import React from 'react';
import {useLocation} from 'react-router-dom';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {WebviewUtils} from '@shared/webviewUtils';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function MaintenancePage() {
  const {t} = useInferableTranslation();
  const {search} = useLocation();
  const params = Object.fromEntries(new URLSearchParams(search));

  return (
    <div className="wrap">
      {/* 점검중일땐 웹뷰 닫기 */}
      <Header right={<HeaderCloseButton onClick={() => WebviewUtils.close()} />} />

      <main
        id="content"
        className="content page_error"
      >
        <section className="section section_error">
          <span className="ic ic_widget_warning_01"></span>
          <h2 className="error_title title_small_b">{t('T40144')}</h2>
          <p
            className="error_desc body_medium_r"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T40145')}
          </p>
          <div className="error_detail_box">
            {params.message && (
              <p
                className="error_detail_desc body_small_b"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {decodeURIComponent(params.message as string)}
              </p>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}

export default MaintenancePage;
